import { render, staticRenderFns } from "./ProjectCreationModal.vue?vue&type=template&id=462902f6&"
import script from "./ProjectCreationModal.vue?vue&type=script&lang=js&"
export * from "./ProjectCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports